import React, { useEffect, useMemo, useState } from "react";
import editIcon from "../assets/edit.png";
import viewIcon from "../assets/View.svg";
import downloadIcon from "../assets/Download.svg";
import leftArrow from "../assets/left-arrow.png";
import rightArrow from "../assets/right-arrow.png";
import downArrow from "../assets/down-arrow.png";
import rightChevron from "../assets/right-chevron.png";
import leftChevron from "../assets/left-chevron.png";
import { downloadPaystub, getPaystubs } from "../api/paystubsApi";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";

const tableData = [
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
  {
    payday: "Feb 23, 2024",
    period: "Feb 11, 2024 - Feb 17, 2024",
    netPay: "$423.50",
    grossPay: "$1,000.00",
    reimbursements: "$0.00",
    employeeTaxes: "$76.50",
  },
];

const Paystubs = () => {
  const [paystubs, setPaystubs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setLoading] = useState(true);
  const companyId = "com_affa65d93030f0118b3d6045bdc7c627";
  const employeeId = "emp_55b194e8f530f0118b3d6045bdc7c627";
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getPaystubs(companyId, employeeId);
        const results = res.data.results || [];

        const mappedData = results.map((item) => {
          const { payday, periodStart, periodEnd, payrollId } = item.payroll;
          const summary = item.summary || {};
          return {
            payrollId,
            payday: new Date(payday).toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
              year: "numeric",
            }),
            period: `${new Date(periodStart).toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
              year: "numeric",
            })} - ${new Date(periodEnd).toLocaleDateString("en-US", {
              month: "short",
              day: "2-digit",
              year: "numeric",
            })}`,
            netPay: `$${(summary.netPay || 0).toFixed(2)}`,
            grossPay: `$${(summary.earnings || 0).toFixed(2)}`,
            reimbursements: `$${(summary.reimbursements || 0).toFixed(2)}`,
            employeeTaxes: `$${(summary.employeeTaxes || 0).toFixed(2)}`,
          };
        });

        setPaystubs(mappedData);
        console.log("=====", mappedData);
      } catch (error) {
        console.error("Error fetching paystubs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [companyId, employeeId]);

  const totalPages = useMemo(
    () => Math.ceil(paystubs.length / rowsPerPage),
    [paystubs, rowsPerPage]
  );
  const startIndex = useMemo(
    () => (currentPage - 1) * rowsPerPage,
    [currentPage, rowsPerPage]
  );
  const currentData = useMemo(
    () => paystubs.slice(startIndex, startIndex + rowsPerPage),
    [paystubs, startIndex, rowsPerPage]
  );

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const handleRowsChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleClick = (companyId, employeeId, payrollId) => {
    navigate(
      `/paystubs/paystubs-detail?companyId=${companyId}&employeeId=${employeeId}&payrollId=${payrollId}`
    );
  };

  return (
    <div className="p-4">
      <h4 className="mb-2 main-title-for-all">Paystubs</h4>
      <p className="gray-text-for-content mb-4">
        Easily view, download, and manage your pay stubs, including detailed
        earnings, deductions, and tax information - all in one place.
      </p>

      <div className="mb-4 bg-white p-4 rounded">
        <div className="table-responsive table-border-layout">
          <table style={{ width: "100%" }}>
            <thead>
              <tr className="table-head">
                <th>Payday</th>
                <th>Period</th>
                <th>Net Pay</th>
                <th>Gross Pay</th>
                <th>Reimbursements</th>
                <th>Employee Taxes</th>
                <th>Action</th>
              </tr>
            </thead>
            {isLoading ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "320%",
                  marginTop: "20%",
                }}
              >
                <Spinner animation="border" />
              </div>
            ) : (
              <tbody className="gray-text-for-content">
                {paystubs?.length > 0 &&
                  paystubs?.map((stub, idx) => (
                    <tr key={idx}>
                      <td>{stub.payday}</td>
                      <td>{stub.period}</td>
                      <td>{stub.netPay}</td>
                      <td>{stub.grossPay}</td>
                      <td>{stub.reimbursements}</td>
                      <td>{stub.employeeTaxes}</td>
                      <td>
                        <button
                          className="border-0 p-0 mx-1"
                          onClick={() =>
                            handleClick(
                              companyId,
                              employeeId,
                              stub?.payroll?.payrollId
                            )
                          }
                        >
                          <img src={viewIcon} alt=" " />
                        </button>
                        <button
                          className="border-0 p-0 mx-1"
                          onClick={() =>
                            downloadPaystub(
                              companyId,
                              employeeId,
                              stub?.payroll?.payrollId
                            )
                          }
                        >
                          <img src={downloadIcon} alt=" " />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
          </table>
        </div>

        <div className="d-flex justify-content-end align-items-center mt-4">
          <div className="d-flex align-items-center">
            <span className="me-2 gray-text-for-content">Rows per page:</span>
            <select
              className="form-select gray-text-for-content border-0"
              style={{ width: "70px" }}
              value={rowsPerPage}
              onChange={handleRowsChange}
            >
              {[5, 10, 15, 20].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex align-items-center ">
            <span className="me-3 gray-text-for-content">
              {currentPage} - {totalPages === 0 ? 1 : totalPages}
            </span>

            <button
              className="me-2 border-0"
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              <img src={leftChevron} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handlePrev}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === 1}
            >
              <img src={leftArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handleNext}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0"
              onClick={() => setCurrentPage(totalPages)}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightChevron} style={{ width: "14px" }} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Paystubs;
